<template>
  <ion-modal id="loading-modal" :is-open="isOpen">
    <div class="load">
      <div class="animation">
        <div class="loading"></div>
        <img class="ai-icon" src="@/assets/student/version5/ai.png" alt="" />
      </div>
      <div class="loading-text">AI正在生成中</div>
      <img
        class="load-icon"
        src="@/assets/student/version5/white_close_icon.png"
        alt=""
        @click="close"
      />
    </div>
  </ion-modal>
</template>

<script setup lang="ts">
import { IonModal } from "@ionic/vue";
import { ref, defineExpose } from "vue";
const isOpen = ref(false);

function open() {
  isOpen.value = true;
}

function close() {
  isOpen.value = false;
}

defineExpose({
  isOpen,
  open,
  close,
});
</script>

<style scoped lang="less">
ion-modal#loading-modal {
  --width: fit-content;
  --min-width: 9.5rem;
  --height: fit-content;
  --border-radius: 0px;
  --box-shadow: transparent;
  --background: transparent;
}
.load {
  position: relative;
  width: 9.5rem;
  height: 9.5rem;
  border-radius: 1rem;
  background: #000000cc;
  color: #ffffff;
  font-size: 0.8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  .animation {
    width: 3.5rem;
    height: 3.5rem;
    position: relative;
    .ai-icon {
      position: absolute;
      top: 46%;
      left: 48%;
      transform: translate(-50%, -50%);
      width: 1.5rem;
      height: 1.5rem;
    }
  }
  /* 添加文字动画 */
  .loading-text {
    /* 原有样式保持不变 */
    position: relative;
  }

  .loading-text::after {
    content: "";
    animation: dots 1.5s infinite steps(4);
  }
  .loading {
    position: relative;
    width: 100%;
    height: 100%;
    border: 0.2rem solid #ffffff4d;
    border-top-color: #ffffff;
    border-right-color: #ffffff;
    border-radius: 100%;

    animation: circle infinite 0.75s linear;
  }

  &-icon {
    width: 0.9rem;
    height: 0.9rem;
    position: absolute;
    right: 0.6rem;
    top: 0.6rem;
    cursor: pointer;
  }
}
@keyframes circle {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dots {
  0% {
    content: "";
  }
  25% {
    content: ".";
  }
  50% {
    content: "..";
  }
  75% {
    content: "...";
  }
  100% {
    content: "";
  }
}
</style>
